import { useCallback, useState, useEffect } from "react";
import API from "../../../services/api";
import { useCurrentUser } from "../../../services/auth";

export function useGetEventList() {
  const [eventList, setEventList] = useState([]);
  const { data } = useCurrentUser();
  const isLoggin = data?.loggedIn;

  const getEventList = useCallback(async () => {
    const response = await API.get(`/getDashboardEvent`);

    setEventList(response.data.data.sort((a, b) => b.id - a.id));
  }, []);

  useEffect(() => {
    if (isLoggin) {
      getEventList();
    }
  }, [isLoggin]);

  return { eventList, getEventList };
}
